<template>
    <div class="UserDrafts" v-observe-visibility="VisibilityChanged" style="display:flex;flex-direction:column; max-height:85vh;">
        <div ref="divtophalf">
            <h2>My Drafts <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
            <div class="row" >
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Drafts:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row" >
                <div class="col-sm-4">
                    <div class="form-group">
                        Displaying {{NumberOfDrafts}} Records
                    </div>
                </div>
            </div>
        </div>
        <div class="row" style="overflow:auto; padding-left:5px;padding-right:5px;">
            <vuetable :fields="DraftsTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      :row-class="onRowClass"
                      class="vue-datatable"
                      ref="datatable"
                      :data-manager="DataManager">


                <template slot="Actions" scope="props">
                    <div class="horizontal-icons-padded">
                        <span><font-awesome-icon :icon="['fa', 'eye']" v-on:click="ViewDocument(props.rowData.PDFFileID, props.rowData.FormLabel, props.rowData.PDFFileName)" class="pointer" /></span>
                        <span><font-awesome-icon :icon="['fa', 'edit']" v-on:click="EditDocument(props.rowData.DocumentID)" class="pointer" /></span>
                        <span><font-awesome-icon :icon="['fas', 'wrench']" v-on:click="OpenDocumentMiscOptions(props.rowData.ChartID, props.rowData.DocumentAuthorEmployeeID, props.rowData.DocumentID)" class="pointer" /></span>
                    </div>


                </template>
            </vuetable>
            
        </div>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
        <DocumentEditor ref="document-editor-modal-component" v-on:draftsupdated="GetDrafts()" :editing-submitted-document="false" />
        <DocumentMiscOptions ref="document-misc-options-modal-component" />
    </div>
</template>

<script>

    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import DocumentEditor from "./DocumentEditor.vue";
    import DocumentViewer from "./DocumentViewer.vue";
    import DocumentMiscOptions from "./DocumentMiscOptions.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faWrench } from '@fortawesome/free-solid-svg-icons';
    library.add(faWrench);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
    library.add(faEyeSlash);

    import { EventBus } from '../../../services/event-bus.js';
    import { TableScrollerSupport } from "../../../mixins/TableScrollerSupport.js";
    export default {
        mixins: [TableScrollerSupport],
        created() {
            EventBus.$on('drafts-updated', chartId => {
                this.GetDrafts();
            });
        },
        beforeDestroy() {
            EventBus.$off('drafts-updated');
        },
        props: [
            "UserId"
        ],
        data: function () {
            return {
                NumberOfDrafts: '',
                search: "",
                Drafts: [],
                DraftsTableOptions: {
                    Fields: [
                        {
                            name: 'FormLabel',
                            title: 'Name',
                            sortField: 'FormLabel'
                        },
                        {
                            name: 'EffectiveDate',
                            title: "Date",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'EffectiveDate'
                        },
                        {
                            name: 'ChartName',
                            title: "Chart Name",
                            sortField: 'ChartName'
                        },
                        {
                            name: 'ChartType',
                            title: "Chart Type",
                            sortField: 'ChartType'
                        },
                        {
                            name: 'DocumentModifiedDate',
                            title: "Last Modified",
                            callback: 'formatDate|MM/DD/YY',
                            sortField: 'DocumentModifiedDate'
                        },
                        {
                            name: '__slot:Actions',
                            title: 'Actions',
                        }
                    ]
                }
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetDrafts();
            },
            GetDrafts() {
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetMyDrafts", {}, this.GetDraftsSuccess, () => { }, false);

            },
            GetDraftsSuccess(response) {
                this.Drafts = response.data.data;
                this.$refs.datatable.refresh();
            },
            EditDocument(documentID) {
                this.$refs['document-editor-modal-component'].ShowExistingDocumentModal(documentID);
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            OpenDocumentMiscOptions(chartID, authorEmployeeID, documentID) {
                this.$refs['document-misc-options-modal-component'].ShowModal(chartID, authorEmployeeID, documentID, true, true, true);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatLongDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD ').format(fmt)
            },
            onRowClass(dataItem, index) {
                if (dataItem.IsRejected) {
                    return "document-rejected-row";
                } else {
                    return "";
                }
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.Drafts);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfDrafts = visibleData.length;
                return visibleData;                  
            },
            
        },
        components: {
            Vuetable,
            DocumentEditor,
            DocumentViewer,
            DocumentMiscOptions
        },
        computed: {
            
        },
        mounted() {

            //Get Child Records*/
            this.GetDrafts();

        }
    }
</script>

<style scoped>
    .horizontal-icons-padded span {
        padding-right: 20px;
    }
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }

    .UserDrafts {
        background-color: white;
    }
</style>